import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';
import PropertyPreviewResource from './PropertyPreviewResource';
import PropertyResource from 'api/service/PropertyResource';
import ContributionResource from 'api/service/ContributionResource';

export default class PropertiesResource extends BaseResource {
  constructor() {
    super({ url: '/api/properties' });
  }

  search(params = {}) {
    const urlParams = objectToUrlParams(params);
    const options = {
      url: `${this.url}/search${urlParams}`,
    };
    return super
      .get(options)
      .then((response) => response)
      .catch((error) => error.response);
  }

  list(params = {}, next = '') {
    const urlParams = objectToUrlParams(params);
    const options = {
      url: `${this.url}${urlParams}`,
      ...(next && {
        headers: { 'x-wb-continuation-token': next },
      }),
    };
    return super
      .get(options)
      .then((response) => response)
      .catch((error) => error.response);
  }

  listFiles(id, params = {}) {
    const urlParams = objectToUrlParams(params);
    const options = {
      url: `${this.url}/${id}/files${urlParams}`,
    };
    return super
      .get(options)
      .then((response) => response)
      .catch((error) => error.response);
  }

  create(data, params = {}) {
    const urlParams = objectToUrlParams(params);

    return super
      .post(data, {
        url: `${this.url}${urlParams}`,
      })
      .then((response) => response)
      .catch((error) => error.response);
  }

  property(id) {
    return new PropertyResource(`${this.url}/${id}`);
  }

  preview(id) {
    return new PropertyPreviewResource(`${this.url}/${id}/preview`);
  }

  contribution(id) {
    return new ContributionResource(`${this.url}/${id}/contributions`);
  }
}
